<template>
  <v-card>
    <v-card-title>{{ creating ? 'Новый документ' : 'Новая редакция PDF' }}</v-card-title>
    <v-card-text>
      <v-alert v-if="error" type="error">{{ error }}</v-alert>
      <v-text-field v-if="creating" v-model="title" label="Название документа" :disabled="saving" maxlength="255" />
      <v-text-field v-if="creating" v-model="type" label="Тип документа" hint="Например: offer, personal_data, terms, privacy" persistent-hint :disabled="saving" maxlength="100" />
      <v-file-input :value="pdf" accept="application/pdf,.pdf" label="Редакция PDF" :disabled="saving" @change="selectPdf" />
      <v-checkbox v-model="acceptanceRequired" label="Обязательное принятие для продолжения работы" :disabled="saving" />
      <v-checkbox v-model="requiresReacceptance" label="Повторное принятие действующими пользователями" :disabled="saving" />
      <p>Повторное принятие задаётся отдельно. Для исправления опечатки его можно не включать.</p>
      <template v-if="previewUrl">
        <a :href="previewUrl" target="_blank" rel="noopener noreferrer">Открыть выбранный PDF</a>
        <iframe :src="previewUrl" title="Предпросмотр новой редакции" class="document-preview" />
      </template>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn text :disabled="saving" @click="$emit('cancel')">Отмена</v-btn>
      <v-btn color="primary" :loading="saving" :disabled="!canSave" @click="save">Сохранить черновик</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: { documentId: { type: [String, Number], default: null } },
  data: () => ({ title: '', type: '', pdf: null, previewUrl: null,
    acceptanceRequired: true, requiresReacceptance: false, saving: false, error: null, selection: 0 }),
  computed: {
    creating() { return this.documentId == null; },
    canSave() { return !this.saving && !!this.pdf && (!this.creating || (!!this.title.trim() && !!this.type.trim())); }
  },
  beforeDestroy() { this.selection++; this.clearPreview(); },
  methods: {
    clearPreview() { if (this.previewUrl) URL.revokeObjectURL(this.previewUrl); this.previewUrl = null; },
    async selectPdf(file) {
      const selection = ++this.selection;
      this.clearPreview(); this.pdf = null; this.error = null;
      if (!file) return;
      try {
        const signature = await file.slice(0, 5).text();
        if (selection !== this.selection) return;
        if (signature !== '%PDF-') throw new Error('Выберите файл в формате PDF.');
        this.pdf = file;
        this.previewUrl = URL.createObjectURL(file);
      } catch (error) {
        if (selection === this.selection) this.error = error.message || 'Не удалось прочитать PDF.';
      }
    },
    async save() {
      if (!this.canSave) return;
      this.saving = true; this.error = null; this.$emit('busy', true);
      try {
        const input = { acceptanceRequired: this.acceptanceRequired, requiresReacceptance: this.requiresReacceptance };
        const document = this.creating
          ? await this.$api.documents.create({ title: this.title.trim(), type: this.type.trim(), ...input }, this.pdf)
          : await this.$api.documents.createRevision(this.documentId, input, this.pdf);
        this.$emit('saved', document);
      } catch (error) { this.error = error.message || 'Не удалось сохранить черновик. Повторите попытку.'; }
      finally { this.saving = false; this.$emit('busy', false); }
    }
  }
};
</script>

<style scoped>
.document-preview { display: block; width: 100%; height: 420px; margin-top: 16px; border: 1px solid #ddd; }
</style>
